import React,{useState} from 'react'
import { Container, Row, Col} from 'react-bootstrap'
import Footer from '../component/Header/Footer';
import { Toaster } from "react-hot-toast";
import toast from "react-hot-toast";
import axios from 'axios';
function ContactBlack()
{

  const [state, setState] = useState({
    name: "",
    email: "",
    phone: "",
    subject: "",
    message: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setState((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

 const handleSubmits = async (e) => 
  {
     console.log("hi");
     e.preventDefault();
     const params = {
       name: state.name,
       email: state.email,
       phone: state.phone,
       subject: state.subject,
       message: state.message,
     };
   
     console.log("Submitting:", params);
     axios.post(`https://modernappforce.com/mappforce/api/modern/email`, params)
    .then(res => {
        console.log(res);
        console.log(res.data);
        setState ({
          name: "",
          email: "",
          phone: "",
          subject: "",
          message: "",
        });
        
        toast.success("Email Send Successfully!");
    })
    .catch(error => console.log(error));
  } 


return(
<>
<section id="app-clasic-faq-main-section">
          <div className="container">
              <div className="app-clasic-faq-text">
                  <h1>Contact Us</h1>
                  <p><span>Home </span> / Contact us</p>
              </div>
          </div>
      </section>
<div id="contactUs" className="bioly-ctn-contact bioly-black-ctn">
  <Container>
    <Row>
      <Col xxl={8} lg={8} md={8} sm={12}>
      <div className="bioly-lft-heading-content bioly-lft-head">
      <span>Get In Touch</span>
      <h2>Feel Free To Contact
        Me Anytimes</h2>
    </div>
        <div className="bioly-ctn-contact-form">
          <form onSubmit={handleSubmits}>
            <Row>
              <Col xxl={6} lg={6} md={6} sm={12}>
                <div className="form-group bioly-ctn-input">
                  <input type="text" name="name" onChange={handleChange} className="form-control" value={state.name} placeholder="Enter Name Here"/>
                </div>
              </Col>
              <Col xxl={6} lg={6} md={6} sm={12}>
                <div className="form-group bioly-ctn-input">
                  <input type="text" name="email" onChange={handleChange} className="form-control" value={state.email} placeholder="Enter Email Address"/>
                </div>
              </Col>
              <Col xxl={6} lg={6} md={6} sm={12}>
                <div className="form-group bioly-ctn-input">
                  <input type="text" name="phone" onChange={handleChange} className="form-control" value={state.phone} placeholder="Enter Phone Number"/>
                </div>
              </Col>

              <Col xxl={6} lg={6} md={6} sm={12}>
                <div className="form-group bioly-ctn-input">
                  <input type="text" name="subject" onChange={handleChange} className="form-control" value={state.subject} placeholder="Enter Subject Here"/>
                </div>
              </Col>

              <Col xxl={12} lg={12} md={12} sm={12}>
                <div className="form-group bioly-ctn-input">
                  <textarea className="form-control" onChange={handleChange} name="message" value={state.message} rows="6" column="50" placeholder="Enter Your Message"></textarea>
                </div>
                <div className="bioly-buttons">
  <button className="bioly-darkans-btn" variant="primary">
    Send Messsage
    <span className="bioly-darkans-btn__inner">
      <span className="bioly-darkans-btn__blobs">
        <span className="bioly-darkans-btn__blob"></span>
        <span className="bioly-darkans-btn__blob"></span>
        <span className="bioly-darkans-btn__blob"></span>
        <span className="bioly-darkans-btn__blob"></span>
      </span>
    </span>
  </button>  
  </div> 
              </Col>


            </Row>
          </form>
        </div>
      </Col>

      <Col xxl={4} lg={4} md={4} sm={12}>
        <div className="bioly-lft-heading-content bioly-lft-heading">
          <span>Contact Us</span>
        </div>
        <div className="bioly-ctn-main-content">
          <div className="bioly-ctn-implement">
            <div className="bioly-ctn-ixcons">
              <img src="imgs/home_four/email.svg" alt="icon-img"/>
            </div>
            <div className="bioly-ctn-implement-head">
              <h4>Email Address</h4>
              <span>info@modernappforce.com</span>
            </div>
          </div>
                  </div>



      </Col>
    
    
    </Row>


  </Container>
</div>
<Toaster position="top-right" reverseOrder={false} />
<Footer/>
</>
);
}
export default ContactBlack;